<ui-card-page>
	<ng-container modal-body>
		<div id="iframe-payment" style="min-height: 650px;min-width: 400px"></div>
	</ng-container>
</ui-card-page>
